import React from 'react'
import Icon from '../index'

const ProfileGroupIcon = ({ color, size }: any) => (
  <Icon color={color} size={size}>
    <path d="M14,12.5 C12.8954305,12.5 12,11.6045695 12,10.5 C12,9.3954305 12.8954305,8.5 14,8.5 C15.1045695,8.5 16,9.3954305 16,10.5 C16,11.6045695 15.1045695,12.5 14,12.5 Z M8,12.5 C6.8954305,12.5 6,11.6045695 6,10.5 C6,9.3954305 6.8954305,8.5 8,8.5 C9.1045695,8.5 10,9.3954305 10,10.5 C10,11.6045695 9.1045695,12.5 8,12.5 Z M14,7.5 C12.8954305,7.5 12,6.6045695 12,5.5 C12,4.3954305 12.8954305,3.5 14,3.5 C15.1045695,3.5 16,4.3954305 16,5.5 C16,6.6045695 15.1045695,7.5 14,7.5 Z M8,7.5 C6.8954305,7.5 6,6.6045695 6,5.5 C6,4.3954305 6.8954305,3.5 8,3.5 C9.1045695,3.5 10,4.3954305 10,5.5 C10,6.6045695 9.1045695,7.5 8,7.5 Z M2,7.5 C0.8954305,7.5 0,6.6045695 0,5.5 C0,4.3954305 0.8954305,3.5 2,3.5 C3.1045695,3.5 4,4.3954305 4,5.5 C4,6.6045695 3.1045695,7.5 2,7.5 Z M2,12.5 C0.8954305,12.5 0,11.6045695 0,10.5 C0,9.3954305 0.8954305,8.5 2,8.5 C3.1045695,8.5 4,9.3954305 4,10.5 C4,11.6045695 3.1045695,12.5 2,12.5 Z" />
  </Icon>
)

ProfileGroupIcon.propTypes = {
  ...Icon.propTypes,
}

export default ProfileGroupIcon
